export type VersionedMappingConfig = {
  config: MappingConfig | null;
  created_at: string;
  version: number;
};

export type MappingConfig = {
  type: MappingType;
  mapping: SupportedMappings;
  version: number;
};

export enum MappingType {
  INVENTORY_UPDATE_CSV = 'INVENTORY_UPDATE_CSV',
  INVENTORY_UPDATE_JSON = 'INVENTORY_UPDATE_JSON',
  ITEM_UPDATE_CSV = 'ITEM_UPDATE_CSV',
  ITEM_UPDATE_JSON = 'ITEM_UPDATE_JSON',
}

export type FieldMapping = {
  query: string;
  field_type: FieldType;
  transform?: PriceTransform;
};

export enum FieldType {
  INTEGER = 'integer',
  DOUBLE = 'double',
  STRING = 'string',
}

export type PriceTransform = {
  type: string;
  value: string;
  multiplier: number;
};

export type InventoryUpdateJson = {
  list_field_path: string;
  sku?: FieldMapping;
  external_id?: FieldMapping;
  gtin?: FieldMapping;
  inventory: FieldMapping;
};

export type InventoryUpdateCsv = {
  sku?: FieldMapping;
  external_id?: FieldMapping;
  gtin?: FieldMapping;
  inventory: FieldMapping;
  num_of_lines_to_skip: number;
  parser?: ParserMetadata;
};

export type ItemUpdateJson = {
  list_field_path: string;
  sku?: FieldMapping;
  external_id?: FieldMapping;
  gtin?: FieldMapping;
  price: FieldMapping;
};

export type ItemUpdateCsv = {
  sku?: FieldMapping;
  external_id?: FieldMapping;
  gtin?: FieldMapping;
  price: FieldMapping;
  num_of_lines_to_skip: number;
  parser?: ParserMetadata;
};

export type ParserMetadata = {
  delimiter: Delimiter;
};

export enum Delimiter {
  COMMA = 'comma',
  PIPE = 'pipe',
  SEMICOLON = 'semicolon',
  SPACE = 'space',
  TAB = 'tab',
}

export type SupportedMappings = InventoryUpdateJson | ItemUpdateJson | InventoryUpdateCsv;
